<template>
  <div class="image-grid">
    <div class="section-header">
      <h3>{{ title }}</h3>
    </div>

    <div ref="scrollContainer" class="scroll-container">
      <div class="grid-wrapper">
        <div
          v-for="(img, index) in duplicatedImages"
          :key="index"
          class="image-item"
        >
          <img :src="typeof img === 'string' ? img : img.url || img.image_url" class="image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageGrid',
  props: {
    title: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => []
    },
    cols: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      ITEM_HEIGHT: 100,
      imagesReady: false,
      scrollTimer: null
    }
  },
  computed: {
    duplicatedImages() {
      return [...this.images, ...this.images]
    },
    totalHeight() {
      const rows = Math.ceil(this.images.length * 2 / this.cols)
      return rows * this.ITEM_HEIGHT
    }
  },
  watch: {
    images() {
      this.preloadImages()
    }
  },
  beforeDestroy() {
    this.stopScroll()
  },
  methods: {
    preloadImages() {
      this.imagesReady = false
      this.stopScroll()

      const urls = this.images.map(item => typeof item === 'string' ? item : item.url || item.image_url)
      if (urls.length === 0) return

      const loadImage = (url) => {
        return new Promise((resolve) => {
          const img = new Image()
          img.onload = resolve
          img.onerror = resolve
          img.src = url
        })
      }

      Promise.all(urls.map(loadImage)).then(() => {
        this.imagesReady = true
        this.$nextTick(() => {
          this.startAutoScroll()
        })
      })
    },
    startAutoScroll() {
      const container = this.$refs.scrollContainer
      if (!container) return

      const scrollHeight = container.scrollHeight
      const clientHeight = container.clientHeight
      if (scrollHeight <= clientHeight) return

      const halfHeight = scrollHeight / 2
      let scrollTop = 0

      this.stopScroll()
      this.scrollTimer = setInterval(() => {
        scrollTop += 1
        if (scrollTop >= halfHeight) {
          container.scrollTop = 0
          scrollTop = 0
        }
        container.scrollTop = scrollTop
      }, 30)
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    }
  }
}
</script>

<style scoped>
.image-grid {
  height: 100%;
  background: rgba(26, 54, 93, 0.6);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(99, 179, 237, 0.2);
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(99, 179, 237, 0.2);
  flex-shrink: 0;
}

h3 {
  font-size: 14px;
  font-weight: 600;
  color: #e2e8f0;
  margin: 0;
}

.scroll-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.scroll-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.grid-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 4px 0;
}

.image-item {
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 6px;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
